module.exports = __webpack_public_path__ + "img/BE0500864745.9ae4c9ba.png";